import { render } from "./SocialMediaComponent.vue?vue&type=template&id=3326fa4f"
import script from "./SocialMediaComponent.vue?vue&type=script&lang=js"
export * from "./SocialMediaComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/SocialMedia/SocialMediaComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3326fa4f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3326fa4f', __exports__)) {
    api.reload('3326fa4f', __exports__)
  }
  
  module.hot.accept("./SocialMediaComponent.vue?vue&type=template&id=3326fa4f", () => {
    api.rerender('3326fa4f', render)
  })

}


export default __exports__